import React from "react";
import {FormGroup, Label, Input, FormFeedback} from "reactstrap";

interface AuthInputProps {
  id: string;
  label: string;
  type:
    | "text"
    | "email"
    | "password"
    | "number"
    | "tel"
    | "url"
    | "search"
    | "date"
    | "time"
    | "datetime-local"
    | "month"
    | "week"
    | "color";
  value?: string;
  defaultValue?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  required?: boolean;
  autoComplete?: string;
  disabled?: boolean;
  maxLength?: number;
  pattern?: string;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  inputRef?: React.RefObject<HTMLInputElement | null>;
}

const AuthInput: React.FC<AuthInputProps> = ({
  id,
  label,
  type,
  value,
  defaultValue,
  onChange,
  placeholder,
  error,
  required = false,
  autoComplete,
  disabled = false,
  maxLength,
  pattern,
  onKeyPress,
  inputRef
}) => {
  // Prefer defaultValue over value for uncontrolled mode (password manager friendly)
  // Only use value if defaultValue is not provided (for other forms that need controlled inputs)
  const useUncontrolled = defaultValue !== undefined;

  return (
    <FormGroup>
      <Label for={id}>
        {label}
        {required && <span className="text-danger"> *</span>}
      </Label>
      <Input
        type={type}
        id={id}
        name={id}
        {...(useUncontrolled ? {defaultValue} : {value})}
        onChange={onChange}
        placeholder={placeholder}
        invalid={!!error}
        required={required}
        autoComplete={autoComplete}
        disabled={disabled}
        maxLength={maxLength}
        pattern={pattern}
        onKeyPress={onKeyPress}
        className="form-control-alternative"
        innerRef={inputRef}
      />
      {error && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>
  );
};

export default AuthInput;
